'use strict';

module.exports = [
    { level: '1', code: 'ELEM', label: 'Elementary School' },
    { level: '2', code: 'SEC', label: 'Some High School' },
    { level: '3', code: 'HS', label: 'High School Graduate' },
    { level: '4', code: 'SCOL', label: 'Some College' },
    { level: '5', code: 'ASSOC', label: 'Associate Degree' },
    { level: '6', code: 'BD', label: 'Bachelor Degree' },
    { level: '7', code: 'PB', label: 'Some Graduate School' },
    { level: '8', code: 'GD', label: 'Graduate/Master Degree' },
    { level: '9', code: 'POSTG', label: 'Doctorate Degree' }
];
